<template>
    <div>
        <table class="table table-sm table-bordered mb-0">
            <tbody>
                <tr>
                    <td class="w-50 font-weight-bolder">Sürücü</td>
                    <td class="w-50">{{$safe(res,'FullName') || '-'}}</td>
                </tr>
                <tr>
                    <td class="w-50 font-weight-bolder">Aktarım Durumu</td>
                    <template v-if="$safe(res,'Success')">
                        <td class="w-50 bg-light-success">Başarılı</td>
                    </template>
                    <template v-else>
                        <td class="w-50 bg-light-danger">Başarısız</td>
                    </template>
                </tr>
            </tbody>
        </table>
        <template v-if="($safe(res,'Errors') || []).length > 0">
            <h4 class="mt-1">Hatalar</h4>
            <ul class="list-group">
                <li class="list-group-item bg-light-danger p-75" v-for="(e,i) in $safe(res,'Errors')" :key="i">
                    {{ e }}
                </li>
            </ul>
        </template>
        
    </div>
</template>

<script>
export default {
    props:{
        result:{
            type:Array,
            default:()=>[]
        },
        currentId:{
            type:[Number,String],
            default:null
        }
    },
    computed:{
        res(){
            return this.result.find(r=>r.Id == this.currentId) || null
        }
    }
}
</script>

<style>

</style>